module.exports = __webpack_public_path__ + "static/media/add-grey-button.879175b5.svg";